export const singlePlanProducts = ['lista-online'];
export const hideChangePlanProducts = ['monitore-clientes', 'lista-online'];
